import { render, staticRenderFns } from "./addBrandBuild.vue?vue&type=template&id=95ed1b02&scoped=true"
import script from "./addBrandBuild.vue?vue&type=script&lang=js"
export * from "./addBrandBuild.vue?vue&type=script&lang=js"
import style0 from "./addBrandBuild.vue?vue&type=style&index=0&id=95ed1b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ed1b02",
  null
  
)

export default component.exports